import { Body, MdSpacing, Row } from '@alto/design-system';
import { type CartItem } from '@alto/orders_api/types/v1/cart_item';
import { type Prescription } from '@alto/scriptdash/alto/patient_app/scheduling/order_bundling/types/v1/prescription';
import React, { Fragment } from 'react';
import { MedContainer, MedSummaryRow } from './MedSummaryRow';

type Props = {
  readonly cartItems: CartItem[];
  readonly earliestUpcomingShipmentID?: number;
  readonly includeSharpsContainer: boolean;
  readonly upcomingBundlePrescriptionIDs?: Prescription['id'][];
};

export const MedSummaryList = ({
  cartItems,
  earliestUpcomingShipmentID,
  includeSharpsContainer,
  upcomingBundlePrescriptionIDs,
}: Props) => {
  return (
    <div>
      {upcomingBundlePrescriptionIDs?.map((id) => (
        <Fragment key={id}>
          <MedSummaryRow
            prescriptionID={id}
            earliestUpcomingShipmentID={earliestUpcomingShipmentID}
          />
          <MdSpacing />
        </Fragment>
      ))}
      {cartItems.map((item) => (
        <Fragment key={`cart-${item.cart_id}-item-${item.resource_id}`}>
          <MedSummaryRow
            prescriptionID={item.resource_id}
            includeNewItemTag={(upcomingBundlePrescriptionIDs || []).length > 0}
          />
          <MdSpacing />
        </Fragment>
      ))}
      {includeSharpsContainer ? (
        <>
          <Row
            spaceBetween
            gap="SM"
          >
            <MedContainer>
              <Body
                fontFamily="semibold"
                textSize="large"
              >
                Sharps Container
              </Body>
            </MedContainer>
            <Row right>
              <Body
                fontFamily="semibold"
                textSize="large"
              >
                Free
              </Body>
            </Row>
          </Row>
        </>
      ) : null}
    </div>
  );
};
